import {createRouter, createWebHistory} from 'vue-router'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/:catchAll(.*)",
      redirect: "/index"
    },
    {
      path:'/index',
      name:'index',
      component:()=> import('@/views/product'),
      meta: {
        title:"首页"
      }
    },
    {
      path:'/detail',
      name:'productDetail',
      component:()=> import('@/views/product/detail'),
      meta: {
        title:"产品详情"
      }
    }
  ],
  scrollBehavior(){
    return {top:0}
  }
})